export default __webpack_public_path__ + "static/role_3-da78c0b1e45572ff87b70140a3c2a4c0.png";